import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Col, List, Modal, message, Radio, Row, Spin } from "antd";
import { Parse } from "parse";
import moment from "moment";

const RadioGroup = Radio.Group;


class MyPoints extends Component {
  constructor(props) {
    super(props);
    this.fidelity = Parse.User.current().attributes.ptsFidelity;
    this.state = {
      loading: true,
      visible: false,
      pointsToSpend: 5000
    };
  }

  async componentDidMount() {
    //query si user n'est pas pro
    this.currentUser = await Parse.User.current().fetch();
    let query = new Parse.Query("Fidelity");
    query.equalTo("user", this.currentUser);
    query.addDescending("createdAt");
    this.results = await query.find();
    this.setState({ loading: false });
  }

  //affichage d'un message en fontcion du mnombre de points de fidélité
  chooseHisto() {
    if (this.state.loading === true) {
      return (
        <div>
          {" "}
          <Spin />{" "}
        </div>
      );
    }
    if (Parse.User.current().attributes.ptsFidelity === 0) {
      return <p>{`Vous n'avez pas encore gagné de points de fidélité !`}</p>;
    }
    return (
      <List
        itemLayout="horizontal"
        dataSource={this.results}
        pagination={{
          pageSize: 5,
          simple: true,
          hideOnSinglePage: true
        }}
        renderItem={item => (
          <List.Item>
            <List.Item.Meta
              title={`${item.attributes.amount} points `}
              description={`${item.attributes.description} (obtenu le ${moment(
                item.createdAt
              ).format("DD MMMM YYYY")})`}
            />
          </List.Item>
        )}
      />
    );
  }

  convertPoints = () => {
    let points = Parse.User.current().attributes.ptsFidelity;
    if (points < 5000)
      return message.error("Vous n'avez pas assez de points de fidélité !");
    this.setState({
      visible: true
    });
  };

  handleClose = e => {
    this.setState({
      visible: false
    });
  };

  handleOk = async () => {
    var ctx = this;
    //this.setState({loading: true});
    let coupon = await Parse.Cloud.run("generateCoupon", {amount: ctx.state.pointsToSpend})
    this.setState({visible: false});
    message.info(`Voici ton coupon promotionnel, note-le bien : ${coupon}`, 60)
  }

  onChangeRadio = e => {
    this.setState({ pointsToSpend: e.target.value });
  };

  getRadio = () => {
    if(this.state.loading === true) return;
    let amount = this.currentUser.attributes.ptsFidelity;
    var disabled1 = false;
    var disabled2 = false;
    var disabled3 = false;
    var disabled4 = false;
    if (amount < 10000) {
      disabled1 = true;
      disabled2 = true;
      disabled3 = true;
      disabled4 = true;
    } else if (amount < 15000) {
      disabled2 = true;
      disabled3 = true;
      disabled4 = true;
    } else if (amount < 20000) {
      disabled3 = true;
      disabled4 = true;
    } else if (amount < 50000) {
      disabled4 = true;
    }

    return (
      <RadioGroup onChange={this.onChangeRadio} value={this.state.pointsToSpend}>
        <Radio  value={5000}>
          5000 points
        </Radio>
        <Radio value={10000} disabled={disabled1}>
          10000 points
        </Radio>
        <Radio  value={15000} disabled={disabled2}>
          15000 points
        </Radio>
        <Radio value={20000} disabled={disabled3}>
          20000 points
        </Radio>
        <Radio value={50000} disabled={disabled4}>
          50000 points
        </Radio>
      </RadioGroup>
    );
  };

  render() {
    return (
      <div>
        <Row type="flex">
          <Col
            span={12}
            style={{
              marginTop: "20px",
              marginBottom: "20px",
              paddingRight: "20px",
              paddingLeft: "20px"
            }}
          >
            <div style={{ textAlign: "center" }}>
              <span style={{ fontSize: "24px", color: "black" }}>
                Total de points:{" "}
              </span>
              <span
                style={{
                  fontSize: "24px",
                  marginLeft: "50px",
                  color: "#0000FE"
                }}
              >
                {this.fidelity} pts
              </span>
            </div>
            <Col style={{ textAlign: "center" }}>
              <Button
                style={{
                  backgroundColor: "#0000FE",
                  color: "white",
                  marginBottom: "15px",
                  marginTop: "15px"
                }}
                onClick={this.convertPoints}
              >
                {`Convertir en bon d'achat`}
              </Button>
              <Modal
                title="Convertir mes points fidélité"
                visible={this.state.visible}
                onOk={this.handleOk}
                onCancel={this.handleClose}
              >
                <div>Combien de points de fidélité voulez-vous convertir ? </div>
                {this.getRadio()}
              </Modal>
            </Col>
            <Col style={{ marginTop: "30px" }}>
              <Col
                span={12}
                style={{
                  textAlign: "center",
                  color: "#0000FE",
                  fontSize: "18px"
                }}
              >
                <h3 style={{ color: "black", fontSize: "24px" }}>Points</h3>
                <p>5 000</p>
                <p>10 000</p>
                <p>15 000</p>
                <p>20 000</p>
                <p>50 000</p>
              </Col>
              <Col span={12} style={{ textAlign: "center", fontSize: "18px" }}>
                <h3 style={{ color: "black", fontSize: "24px" }}>Réduction</h3>
                <p>5 €</p>
                <p>10 €</p>
                <p>20 €</p>
                <p>30 €</p>
                <p>50 €</p>
              </Col>
            </Col>
          </Col>
          <Col
            span={12}
            style={{
              marginTop: "20px",
              marginBottom: "20px",
              paddingRight: "20px",
              paddingLeft: "20px"
            }}
          >
            <Col style={{ textAlign: "center" }}>
              <span style={{ fontSize: "24px", color: "black" }}>
                Mon historique
              </span>
              {this.chooseHisto()}
            </Col>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = globalReducers => globalReducers;
const connectedMyPoints = connect(
  mapStateToProps,
  null
)(MyPoints);
export default connectedMyPoints;
